
export interface LoanRequestModel
{
    LoanPurpose?: number;
    LoanAmount?: number;
    LoanDuration?: number;  
    CustomerId?: string;
    BrowserName: string;
}

export interface ApplyLoan 
{
    CustomerId: string,
    SectionId: number,
    LogId: number,
    ProductId: number,
    ProductName: string,
    CorrelationId: string,
}

export class KeyFactModel {
    constructor(
      public employmentStatuses: string,
      public ageMin: string,
      public existingCustomersOnly: string,
      public earlyRepaymentPenalty: string,
      public fundsAvailableOnSameDay: string,
      public defermentAllowed: string,
    ) { }
  }